import { createContext, useContext } from "react";

export const STR = {
  en: {
    "nav.home": "Home",
    "nav.dhamma": "Dhamma",
    "nav.monk": "The Monk",
    "nav.about": "About",
    "nav.ourwork": "Our Work",
    "nav.nalanda": "Nalanda",
    "nav.journey": "Our Journey",
    "nav.media": "Media",
    "nav.contact": "Contact",
    "nav.donate": "Offer Support",
    "common.learnMore": "Learn More",

    "hero.eyebrow": "International Buddhist Monks Charitable Trust",
    "hero.title1": "Compassion ",
    "hero.titleAccent": "in Action.",
    "hero.title2": "Dhamma in Service.",
    "hero.intro": "Rooted in the Buddha’s teachings of compassion, wisdom and generosity, IBMCT seeks to bring dignity, care and opportunity to communities in need.",
    "hero.cta1": "Explore Our Work",
    "hero.cta2": "Discover the Dhamma",
    "hero.values": "Compassion · Dhamma · Service · Humanity",
    "hero.scroll": "Scroll",

    "journey.eyebrow": "Ways to Be Part of the Journey",
    "journey.heading": "How You Can Walk With Us",
    "journey.intro": "Different paths, one shared spirit of compassion. Each of these is a door into the community — enter through the one that speaks to you.",
    "journey.learn.title": "Learn",
    "journey.learn.body": "Explore the Dhamma — the Buddha’s teachings that guide every initiative of IBMCT.",
    "journey.learn.cta": "Discover the Dhamma",
    "journey.practice.title": "Practice",
    "journey.practice.body": "Sit in meditation, join a Dhamma talk, or spend time in study at the Nalanda centre.",
    "journey.practice.cta": "Explore Nalanda",
    "journey.serve.title": "Serve",
    "journey.serve.body": "Offer your time and skills alongside our monastics and community volunteers.",
    "journey.serve.cta": "Volunteer With Us",
    "journey.give.title": "Give",
    "journey.give.body": "Support the elders, women and children the Trust is working to serve, through dāna.",
    "journey.give.cta": "Offer Support",
    "journey.visit.title": "Visit",
    "journey.visit.body": "Come see the work in person, meet the community, and stay in touch.",
    "journey.visit.cta": "Get in Touch",

    "work.eyebrow": "Compassion in Action",
    "work.heading": "Three Expressions of Compassion",
    "work.subhead": "Different needs. One commitment to compassionate service.",
    "work.beyondHeading": "Dhamma · Education · Health · Community",
    "work.beyondIntro": "IBMCT’s work extends beyond its flagship programs.",
    "work.explore": "Explore All Our Work",
    "work.tag": "Flagship Program",

    "ow.heroEyebrow": "Compassion in Action",
    "ow.heroTitle": "Three Initiatives. One Great Resolve.",
    "ow.heroIntro": "Guided by the values of compassion, generosity and dignity, IBMCT expresses the spirit of Dhamma through meaningful service to people and communities.",
    "ow.introEyebrow": "Where Compassion Lives",
    "ow.introHeading": "Homes, Shelters and New Beginnings",
    "ow.introBody": "Each flagship program answers a specific human need — a home for elders, safety for women, a beginning for children. Unveiled together at Maha Karuna 2026 under one great resolve, each is run with the same conviction: that dignity is not a privilege, but a right.",
    "ow.introLykit": "IBMCT (International Buddhist Monks Charitable Trust), in collaboration with Lykit Entertainment Pvt. Ltd., has taken this initiative forward with the belief that meaningful change begins when compassion becomes action.",
    "ow.introCta": "Support Our Programs",
    "ow.flagshipEyebrow": "Our Service Initiatives",
    "ow.communityEyebrow": "Community Services",
    "ow.communityHeading": "Beyond the Flagship Programs",
    "ow.communityIntro": "IBMCT’s work extends into every corner of community life — from the meditation hall to the medical camp.",
    "ow.volunteer": "Volunteer With Us",
    "ow.donate": "Donate to Our Work",

    "detail.back": "Back to Our Work",
    "detail.support": "Support This Work",
    "detail.volunteer": "Volunteer With Us",
    "detail.facilities": "What the Campus Will Offer",
    "detail.karunaNote": "Unveiled at Maha Karuna 2026 — Three Projects, One Great Resolve",
    "detail.campus": "Campus",
    "detail.phase1": "Phase 1",
    "detail.vision": "Full Vision",
    "detail.notFound": "Page Not Found",
    "detail.notFoundBody": "The program you are looking for does not exist.",
    "detail.explore": "Explore Our Work",

    // ---------------- ABOUT ----------------
    "about.heroEyebrow": "About IBMCT",
    "about.heroTitle": "A Trust Rooted in the Dhamma",
    "about.heroIntro": "The International Buddhist Monks Charitable Trust is a Karnataka-registered charitable trust serving communities through care, education, healthcare and the timeless wisdom of the Buddha.",
    "about.storyEyebrow": "Who We Are",
    "about.storyHeading": "IBMCT – International Buddhist Monks Charitable Trust",
    "about.storyFounders": "Venerable Bhante Dhammananda and Venerable Bhante Bodhidatta Thera",
    "about.storyP1": "The IBMCT – International Buddhist Monks Charitable Trust is an institution established with the noble and selfless objective of providing continuous services that benefit millions of people.",
    "about.storyP2": "With the support and cooperation of Venerable Bhante Bodhidatta Thera and the late R. Dhruvanarayana, who was then a Member of Parliament, several padayatras (foot marches) were undertaken and donations were collected from generous donors. In 2017, 25 acres of land were officially purchased by the Government for this purpose.",
    "about.storyP3": "The institution envisioned establishing the Nalanda Knowledge and Study Centre on this land, near the Government Medical College, at Edabetta, Uthuvalli, Chamarajanagar – 571313.",
    "about.storyP4": "In 2018, under the direction of the then Hon’ble Chief Minister Shri Siddaramaiah, the Government sanctioned a grant of ₹10 crore for the construction of the Nalanda Knowledge and Study Centre. The responsibility for carrying out the construction was entrusted to a division of the Indian Railways.",
    "about.storyP5": "Subsequently, in 2020, the Government of Karnataka and the Railway Department commenced the construction work of the building. The entire construction project was successfully completed in 2024, after which the completed facility was handed back to the institution.",
    "about.visionEyebrow": "Our Vision",
    "about.visionHeading": "A World Where Compassion Is Lived, Not Just Spoken",
    "about.vision1Title": "Dignity for All",
    "about.vision1Body": "Every elder, woman and child deserves safety, nourishment and respect — regardless of circumstance.",
    "about.vision2Title": "Wisdom in Service",
    "about.vision2Body": "The teachings of the Buddha guide not only our meditation halls, but our shelters, homes and classrooms.",
    "about.vision3Title": "Communities That Endure",
    "about.vision3Body": "We build institutions — homes, schools, a study centre — that outlast any single effort and serve generations.",
    "about.journeyEyebrow": "Our Journey",
    "about.journeyHeading": "Milestones of Service",
    "about.meetLeader": "Meet Our General Secretary",
    "about.exploreWork": "Explore Our Work",

    // ---------------- NALANDA ----------------
    "nal.heroEyebrow": "Nalanda Study Centre",
    "nal.heroTitle": "Reviving the Spirit of Nalanda",
    "nal.heroIntro": "A living centre for Dhamma, meditation, scholarship and cultural preservation — completed in 2024 in Karnataka.",
    "nal.projectEyebrow": "The Project",
    "nal.projectHeading": "A Beacon of Buddhist Learning",
    "nal.projectP1": "Fifteen centuries ago, Nalanda was the world’s great university of Buddhist thought — drawing scholars from across Asia. The Nalanda Study Centre honours that legacy with a modern mission: a place where the Dhamma is studied, practised and shared freely with all.",
    "nal.projectP2": "The centre will house meditation halls, classrooms, a public library of Buddhist literature, residential quarters for monastics and students, and spaces for interfaith dialogue and cultural preservation.",
    "nal.progressLabel": "Construction Status",
    "nal.progressValue": "Completed in 2024",
    "nal.constructionEyebrow": "Construction",
    "nal.constructionHeading": "From Donated Land to Living Centre",
    "nal.phase1Year": "2017",
    "nal.phase1Title": "Land Purchased",
    "nal.phase1Body": "A generous devotee donates land in Karnataka for a centre of Buddhist learning — the seed of the Nalanda Study Centre is planted.",
    "nal.phase2Year": "2021",
    "nal.phase2Title": "Construction Began",
    "nal.phase2Body": "With blessings and the support of donors, foundation work begins. The vision takes physical form: meditation halls, study rooms, a library and residential quarters.",
    "nal.phase3Year": "2024",
    "nal.phase3Title": "Completed",
    "nal.phase3Body": "The centre was completed in 2024 and handed back to the institution — its halls, library and residential quarters now ready to welcome those who come to study, meditate and serve.",
    "nal.supportEyebrow": "Support Nalanda",
    "nal.supportHeading": "Help Sustain the Vision",
    "nal.supportIntro": "Your continued generosity sustains the centre’s mission — the halls where thousands will meditate, study and find peace for generations to come.",
    "nal.support1Title": "Sponsor a Room",
    "nal.support1Body": "Fund the completion of a meditation hall, study room or residential quarter in your name or in memory of a loved one.",
    "nal.support2Title": "Build the Library",
    "nal.support2Body": "Contribute towards books, manuscripts and study materials for the growing Nalanda collection.",
    "nal.support3Title": "Monthly Dana",
    "nal.support3Body": "A recurring monthly contribution keeps construction moving steadily towards completion.",
    "nal.donateCta": "Donate to Nalanda",
    "nal.contactCta": "Discuss Sponsorship",

    // ---------------- DONATE ----------------
    "donate.heroEyebrow": "Dāna — the Practice of Generosity",
    "donate.heroTitle": "Your Offering. Their Dignity.",
    "donate.heroIntro": "In the Buddha’s teaching, dāna — the practice of giving — is the first step on the path of awakening. Every offering, large or small, becomes food, healthcare, education, elder care and women’s empowerment in the communities IBMCT serves. Contributions are eligible for 80G tax exemption.",
    "donate.tab.online": "Online / UPI",
    "donate.tab.bank": "Bank Transfer",
    "donate.tab.receipt": "Receipt & 80G",
    "donate.online.eyebrow": "Online Giving",
    "donate.online.heading": "Give Instantly via UPI",
    "donate.online.trustLabel": "Trust Name",
    "donate.online.trustValue": "International Buddhist Monks Charitable Trust",
    "donate.online.upiLabel": "UPI ID",
    "donate.online.upiValue": "Shared on request — email us to receive it",
    "donate.online.note1": "For the security of our donors, IBMCT shares its verified UPI ID directly rather than publishing it online. Write to",
    "donate.online.note2": "with the subject “Donation — UPI Details” and we will respond promptly.",
    "donate.bank.eyebrow": "Bank Transfer (NEFT / RTGS / IMPS)",
    "donate.bank.heading": "Direct Bank Transfer",
    "donate.bank.bankNameLabel": "Bank Name",
    "donate.bank.bankNameValue": "Equitas Small Finance Bank",
    "donate.bank.accountLabel": "Account Number",
    "donate.bank.ifscLabel": "IFSC",
    "donate.bank.branchLabel": "Branch",
    "donate.bank.branchValue": "Basaveshwar Nagar",
    "donate.bank.addressLabel": "Bank Address",
    "donate.bank.addressValue": "No. 92, LIC Colony, Basaveshwaranagar Main Road, Bengaluru – 560079",
    "donate.bank.note1": "After transferring, please email",
    "donate.bank.note2": "with your transaction reference so the Trust can issue your official receipt and 80G certificate.",
    "donate.receipt.eyebrow": "Receipt & 80G Tax Exemption",
    "donate.receipt.heading": "Your Donation Receipt",
    "donate.receipt.body": "All donations to IBMCT are eligible for tax exemption under Section 80G of the Income Tax Act. To receive your official receipt and 80G certificate, please email the following after your donation:",
    "donate.receipt.step1": "Your full name and postal address",
    "donate.receipt.step2": "Transaction reference number / UTR and date of transfer",
    "donate.receipt.step3": "PAN (required for 80G certificate)",
    "donate.receipt.step4": "Donation amount and the program you wish to support (optional)",
    "donate.receipt.note1": "Send to",
    "donate.receipt.note2": "— receipts are issued within 7 working days.",
    "donate.trustNotice": "IBMCT is a registered charitable trust (Reg: BK 4 IV 59/12-13 · LEI: 984500F817DEBC7D0R18). Donations are eligible for 80G Tax Exemption. Every rupee is accounted for and directed to the cause you choose.",
    "donate.quote": "“If you knew, as I do, the power of giving, you would not let a single meal pass without sharing it.”",
    "donate.quoteAttr": "— The Buddha",
    "donate.contactCta": "Questions About Giving? Contact Us",

    // ---------------- CONTACT ----------------
    "contact.heroEyebrow": "Contact",
    "contact.heroTitle": "Reach Out to IBMCT",
    "contact.heroIntro": "Whether you have a question, wish to volunteer, or want to support our work — we welcome you.",
    "contact.findEyebrow": "Find Us",
    "contact.findHeading": "Visit or Write",
    "contact.addressLabel": "Address",
    "contact.emailLabel": "Email",
    "contact.quote": "“Hatred is never appeased by hatred in this world. By non-hatred alone is hatred appeased.”",
    "contact.quoteAttr": "— Dhammapada, Verse 5",
    "contact.formHeading": "Send an Enquiry",
    "contact.form.name": "Name *",
    "contact.form.namePh": "Your full name",
    "contact.form.email": "Email *",
    "contact.form.emailPh": "you@example.com",
    "contact.form.phone": "Phone (optional)",
    "contact.form.phonePh": "+91 …",
    "contact.form.org": "Organisation (optional)",
    "contact.form.orgPh": "Organisation name",
    "contact.form.subject": "Subject *",
    "contact.form.subjectPh": "How can we help?",
    "contact.form.message": "Message *",
    "contact.form.messagePh": "Write your message…",
    "contact.form.sending": "Sending…",
    "contact.form.submit": "Send Enquiry →",
    "contact.toast.success": "Your enquiry has been sent. We will respond soon. Bhavatu Sabba Mangalam.",
    "contact.toast.error": "Something went wrong. Please try again or email us directly.",
  },
};

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const LangProvider = ({ children }) => {
  const t = (key) => STR.en[key] ?? key;
  return <LangContext.Provider value={{ lang: "en", setLang: () => {}, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
